import React from 'react';

const Layout = ({ children } : { children: React.ReactNode }) => (
  <main><article>{children}</article></main>
);

export default Layout;
